<div class="modal-header">
  <div class="h4 modal-title">
    Doc. Analyzer
  </div>
</div>

<div class="modal-body">
  <!-- Banner di esito -->
  <div
    *ngIf="feedback"
    class="alert d-flex align-items-center justify-content-between py-2 mb-3"
    [class.alert-success]="feedback.kind === 'success'"
    [class.alert-danger]="feedback.kind === 'error'"
    role="alert">
    <div class="small">
      {{ feedback.messageKey | translate }}
      <span *ngIf="feedback.detail" class="text-muted"> — {{ feedback.detail }}</span>
    </div>
    <button type="button" class="btn-close btn-close-sm" aria-label="Close" (click)="feedback = null"></button>
  </div>

  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

    <!-- TAB: Riepilogo -->
    <li [ngbNavItem]="'summary'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.SUMMARY' | translate }}</button>
      <ng-template ngbNavContent>

        <!-- Intestazione documento -->
        <ng-container *ngIf="documentInfo$ | async as doc">
          <div class="doc-header d-flex align-items-center p-3 border rounded bg-light mb-3">
            <div class="doc-header__icon flex-shrink-0 d-flex align-items-center justify-content-center">
              <pt-icon
                *ngIf="doc.headerIconKey"
                [key]="doc.headerIconKey"
                [size]="40"
                [iconType]="IconType.SVG"
              ></pt-icon>
            </div>
            <div class="doc-header__body flex-grow-1 min-w-0 ms-3">
              <div class="doc-header__title text-truncate">
                {{ doc.name || ('LABELS.UNNAMED_DOCUMENT' | translate) }}
              </div>
              <div class="doc-header__meta d-flex flex-wrap align-items-center gap-2">
                <span class="badge text-bg-secondary">{{ doc.docType }}</span>
                <span class="badge text-bg-light text-dark border">{{ doc.status }}</span>
                <span *ngIf="doc.headerEntityName" class="text-muted small">
                  {{ doc.headerEntityName | translate }}
                </span>
              </div>
            </div>
            <div class="doc-header__id text-end flex-shrink-0 ms-3 small text-muted">
              <div>ID: <code>{{ doc.docId }}</code></div>
              <div *ngIf="doc.updatedAt">
                <span>Ultimo aggiornamento del documento: </span>{{ doc.updatedAt | date : 'dd/MM/yyyy HH:mm' }}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Overview -->
        <h6 class="text-muted small mb-2 mt-3">{{ 'LABELS.OVERVIEW' | translate }}</h6>
        <div class="row g-2 mb-3">

          <!-- Creatore -->
          <ng-container *ngIf="documentInfo$ | async as doc">
            <div class="col-6 col-md-3">
              <div class="stat-card border rounded p-2 text-center">
                <div class="small text-muted text-truncate d-flex align-items-center justify-content-center gap-1">
                  {{ 'LABELS.CREATOR_USER' | translate }}
                  <ng-container *ngIf="creatorUser()">
                    <pt-icon
                      class="d-flex tooltip-icon text-muted"
                      key="information-circle-outline"
                      [size]="14"
                      [ngbTooltip]="creatorTooltip"
                      placement="bottom"
                      tooltipClass="tooltip-lg"
                    ></pt-icon>
                  </ng-container>
                </div>
                <ng-container *ngIf="creatorUser(); else noCreator">
                  <div class="h5 mb-0">
                    {{ creatorUser()?.name }} {{ creatorUser()?.surname }}
                    <small class="text-muted">#{{ doc.creatorUserId }}</small>
                  </div>
                </ng-container>
                <ng-template #noCreator>
                  <div class="h5 mb-0 text-muted">—</div>
                </ng-template>
              </div>
            </div>

            <ng-template #creatorTooltip>
              <div class="text-start p-1">
                <div class="fw-bold mb-1">{{ creatorUser()?.name }} {{ creatorUser()?.surname }}</div>
                <div class="small mb-1"><span class="text-muted">Username:</span> {{ creatorUser()?.username }}</div>
                <div class="small mb-1"><span class="text-muted">Email:</span> {{ creatorUser()?.email }}</div>
                <div class="small mb-1" *ngIf="creatorUser()?.phone">
                  <span class="text-muted">Telefono:</span> {{ creatorUser()?.phone }}
                </div>
                <hr class="my-2 border-secondary">
                <div class="d-flex flex-wrap gap-1">
                  <span class="badge bg-secondary" *ngIf="creatorUser()?.system">System</span>
                  <span class="badge bg-secondary" *ngIf="creatorUser()?.builtIn">Built-in</span>
                  <span class="badge bg-success" *ngIf="creatorUser()?.active">Attivo</span>
                  <span class="badge bg-danger" *ngIf="creatorUser()?.locked">Bloccato</span>
                </div>
              </div>
            </ng-template>
          </ng-container>

          <!-- Accesso + Operazioni + Warning -->
          <ng-container *ngIf="documentPermission$ | async as perm">
            <div class="col-6 col-md-3">
              <div class="stat-card border rounded p-2 text-center">
                <div class="small text-muted text-truncate">{{ 'LABELS.ACCESS' | translate }}</div>
                <div class="h5 mb-0">
                  <span class="badge"
                        [class.text-bg-success]="perm.access === DocAccess.FULL"
                        [class.text-bg-warning]="perm.access === DocAccess.READ_ONLY"
                        [class.text-bg-secondary]="perm.access !== DocAccess.FULL && perm.access !== DocAccess.READ_ONLY">
                    {{ perm.access || '—' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3">
              <div class="stat-card border rounded p-2 text-center">
                <div class="small text-muted text-truncate d-flex align-items-center justify-content-center gap-1">
                  {{ 'LABELS.ALLOWED_OPERATIONS' | translate }}
                  <pt-icon
                    *ngIf="perm.operations?.length"
                    class="d-flex tooltip-icon text-muted"
                    key="information-circle-outline"
                    [size]="14"
                    [ngbTooltip]="operationsTooltip"
                    placement="bottom"
                    tooltipClass="tooltip-lg"
                  ></pt-icon>
                </div>
                <div class="h5 mb-0">{{ perm.operations?.length || 0 }}</div>
              </div>
            </div>

            <ng-template #operationsTooltip>
              <div class="text-start p-1">
                <div class="fw-bold mb-2">Operazioni consentite</div>
                <ul class="list-unstyled mb-0">
                  <li *ngFor="let op of perm.operations" class="small mb-1">
                    • {{ op }}
                  </li>
                </ul>
              </div>
            </ng-template>
          </ng-container>

          <!-- Warnings -->
          <ng-container *ngIf="commonDocumentEditorDetails as details">
            <div class="col-6 col-md-3">
              <div class="stat-card border rounded p-2 text-center">
                <div class="small text-muted text-truncate d-flex align-items-center justify-content-center gap-1">
                  {{ 'LABELS.WARNINGS' | translate }}
                  <pt-icon
                    *ngIf="details.warnings?.length"
                    class="d-flex tooltip-icon text-warning"
                    key="warning-outline"
                    [size]="14"
                    [ngbTooltip]="warningsTooltip"
                    placement="bottom"
                    tooltipClass="tooltip-lg"
                  ></pt-icon>
                </div>
                <div class="h5 mb-0" [class.text-danger]="(details.warnings?.length || 0) > 0">
                  {{ details.warnings?.length || 0 }}
                </div>
              </div>
            </div>

            <ng-template #warningsTooltip>
              <div class="text-start p-1">
                <div class="fw-bold mb-2">Warning attivi</div>
                <ul class="list-unstyled mb-0">
                  <li *ngFor="let w of details.warnings" class="small mb-1">
                    {{ 'MESSAGE.' + w | translate }}
                  </li>
                </ul>
              </div>
            </ng-template>
          </ng-container>

        </div>

        <!-- Capitolo -->
        <ng-container *ngIf="getActiveChapterInfo$ | async as chapter">

          <div class="chapter-info-bar border rounded p-3 mb-3 d-flex align-items-center gap-3 flex-wrap">

            <!-- Sinistra: nome + metadati -->
            <div class="d-flex align-items-center gap-3 flex-wrap">

              <div class="d-flex flex-column">
                <span class="text-muted" style="font-size: 0.7rem; line-height: 1">Capitolo Corrente</span>
                <div class="d-flex align-items-center gap-2 mt-1">
                  <pt-icon class="d-flex text-muted" key="document-text-outline" [size]="18"></pt-icon>
                  <strong class="text-dark fs-6">{{ chapter.name }}</strong>
                </div>
              </div>

              <span class="vr align-self-stretch"></span>

              <div class="d-flex flex-column">
                <span class="text-muted" style="font-size: 0.7rem; line-height: 1">Selettore</span>
                <code class="text-dark small mt-1">{{ chapter.selector }}</code>
              </div>

              <span class="vr align-self-stretch"></span>

              <div class="d-flex flex-column">
                <span class="text-muted" style="font-size: 0.7rem; line-height: 1">Stato attuale</span>
                <div class="mt-1">
                  <span class="badge text-bg-secondary">{{ chapter.currentStatus }}</span>
                </div>
              </div>

            </div>

            <!-- Destra: data + autore -->
            <div class="ms-auto d-flex align-items-center gap-3 flex-wrap">

              <div class="d-flex flex-column align-items-start">
                <span class="text-muted" style="font-size: 0.7rem; line-height: 1">Ultimo aggiornamento</span>
                <div class="d-flex align-items-center gap-1 mt-1">
                  <pt-icon class="d-flex text-muted" key="time-outline" [size]="13"></pt-icon>
                  <strong class="text-dark small">{{ chapter.lastUpdatedAt | date : 'dd/MM/yyyy HH:mm' }}</strong>
                </div>
              </div>

              <span class="vr align-self-stretch"></span>

              <div class="d-flex flex-column align-items-start">
                <span class="text-muted" style="font-size: 0.7rem; line-height: 1">Autore</span>
                <div class="d-flex align-items-center gap-1 mt-1">
                  <pt-icon class="d-flex text-muted" key="person-outline" [size]="13"></pt-icon>
                  <strong class="text-dark small">{{ chapter.lastUpdateUser?.username ?? '—' }}</strong>
                </div>
              </div>

            </div>

          </div>

          <ng-container *ngIf="status$ | async as status">

            <!-- Gruppi -->
            <h6 class="text-muted small mb-2 mt-3">{{ 'LABELS.GROUPS' | translate }}</h6>
            <div class="row g-2 mb-3">
              <div class="col-6 col-md-4">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted">Caricati</div>
                  <div class="h5 mb-0">{{ status.loadedGroupId?.length || 0 }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted">Completati</div>
                  <div class="h5 mb-0 text-success">{{ status.validGroupId?.length || 0 }}</div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted">Abilitati</div>
                  <div class="h5 mb-0 text-success">
                    {{ getEnabledGroups(groups$ | async)  }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Widget -->
            <h6 class="text-muted small mb-2 mt-3">{{ 'LABELS.WIDGETS' | translate }}</h6>
            <div class="row g-2 mb-3">
              <div class="col-4 col-md-2">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted text-truncate">{{ 'LABELS.TOTAL' | translate }}</div>
                  <div class="h5 mb-0">{{ status.totalWidget }}</div>
                </div>
              </div>
              <div class="col-4 col-md-2">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted text-truncate">{{ 'LABELS.LOADED' | translate }}</div>
                  <div class="h5 mb-0">{{ status.loadedWidgetId?.length || 0 }}</div>
                </div>
              </div>
              <div class="col-4 col-md-2">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted text-truncate">{{ 'LABELS.ENABLED' | translate }}</div>
                  <div class="h5 mb-0">{{ status.enabledWidgetId?.length || 0 }}</div>
                </div>
              </div>
              <div class="col-4 col-md-2">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted text-truncate">{{ 'LABELS.VALID' | translate }}</div>
                  <div class="h5 mb-0 text-success">{{ status.validWidgetId?.length || 0 }}</div>
                </div>
              </div>

              <!-- Errori -->
              <div class="col-4 col-md-2">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted text-truncate d-flex align-items-center justify-content-center gap-1">
                    {{ 'LABELS.ERRORS' | translate }}
                    <pt-icon
                      class="d-flex tooltip-icon"
                      [class.text-muted]="(status.errorWidgetId?.length || 0) === 0"
                      [class.text-warning]="(status.errorWidgetId?.length || 0) > 0"
                      key="information-circle-outline"
                      [size]="14"
                      [ngbTooltip]="errorsTooltip"
                      placement="bottom"
                      tooltipClass="tooltip-lg"
                    ></pt-icon>
                  </div>
                  <div
                    class="h5 mb-0"
                    [class.text-success]="(status.errorWidgetId?.length || 0) === 0"
                    [class.text-warning]="(status.errorWidgetId?.length || 0) > 0"
                  >
                    {{ status.errorWidgetId?.length || 0 }}
                  </div>
                </div>
              </div>

              <ng-template #errorsTooltip>
                <div class="text-start p-1">
                  <div class="fw-bold mb-2">Errori widget</div>
                  <div class="small mb-2">Il valore indica il numero di errori nei resolve dei widget.</div>
                  <div *ngIf="(status.errorWidgetId?.length || 0) > 0" class="small text-warning">
                    In caso di errore, verificare la rete (Network).
                  </div>
                  <div *ngIf="(status.errorWidgetId?.length || 0) === 0" class="small text-success">
                    Nessun errore rilevato.
                  </div>
                </div>
              </ng-template>

              <div class="col-4 col-md-2">
                <div class="stat-card border rounded p-2 text-center">
                  <div class="small text-muted text-truncate">{{ 'LABELS.VALIDITY_RATE' | translate }}</div>
                  <div class="h5 mb-0">{{ validityRate(status) }}%</div>
                </div>
              </div>
            </div>
            <div
              *ngIf="!canSaveContext(chapter, documentInfo$ | async)"
              class="alert alert-warning small py-2 mb-2"
            >
              {{ 'PAGE.COMPLETE_STATUS.NOT_SAVABLE_HINT' | translate }}
            </div>
          </ng-container>

          <!-- Slider -->
          <div class="mb-2">
            <label for="completed" class="form-label d-flex justify-content-between">
              <span>Percentuale di completamento (salvata nel DB)</span>
              <strong>{{ completedCtrl.value }}%</strong>
            </label>
            <input id="completed" type="range" class="form-range" min="0" max="100" step="1" [formControl]="completedCtrl"/>
            <div class="progress mt-2" style="height: 8px;">
              <div
                class="progress-bar"
                role="progressbar"
                [style.width.%]="completedCtrl.value"
                [attr.aria-valuenow]="completedCtrl.value"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <small *ngIf="completedCtrl.invalid && completedCtrl.touched" class="text-danger">
              {{ 'PAGE.COMPLETE_STATUS.VALIDATION.COMPLETED_RANGE' | translate }}
            </small>
          </div>
        </ng-container>

      </ng-template>
    </li>

    <!-- TAB: Stato widget -->
    <li [ngbNavItem]="'status'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.WIDGETS_STATUS' | translate }}</button>
      <ng-template ngbNavContent>
        <ng-container *ngIf="status$ | async as statusData">
          <div class="tab-content-scroll position-relative">
            <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(statusData)">
              <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
              Copia
            </button>
            <pre class="bg-light p-3 rounded small mb-0 h-100">{{ statusData | json }}</pre>
          </div>
        </ng-container>
      </ng-template>
    </li>

    <!-- TAB: Capitolo -->
    <li [ngbNavItem]="'chapter'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.CHAPTER' | translate }}</button>
      <ng-template ngbNavContent>
        <ng-container *ngIf="getActiveChapterInfo$ | async as chapterData">
          <div class="tab-content-scroll position-relative">
            <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(chapterData)">
              <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
              Copia
            </button>
            <pre class="bg-light p-3 rounded small mb-0 h-100">{{ chapterData | json }}</pre>
          </div>
        </ng-container>
      </ng-template>
    </li>

    <!-- TAB: Informazioni documento -->
    <li [ngbNavItem]="'docInfo'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.DOC_INFO' | translate }}</button>
      <ng-template ngbNavContent>
        <ng-container *ngIf="documentInfo$ | async as docInfoData">
          <div class="tab-content-scroll position-relative">
            <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(docInfoData)">
              <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
              Copia
            </button>
            <pre class="bg-light p-3 rounded small mb-0 h-100">{{ docInfoData | json }}</pre>
          </div>
        </ng-container>
      </ng-template>
    </li>

    <!-- TAB: Permessi -->
    <li [ngbNavItem]="'permissions'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.PERMISSIONS' | translate }}</button>
      <ng-template ngbNavContent>
        <ng-container *ngIf="documentPermission$ | async as permData">
          <div class="tab-content-scroll position-relative">
            <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(permData)">
              <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
              Copia
            </button>
            <pre class="bg-light p-3 rounded small mb-0 h-100">{{ permData | json }}</pre>
          </div>
        </ng-container>
      </ng-template>
    </li>

    <!-- TAB: Dettagli editor -->
    <li [ngbNavItem]="'editorDetails'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.EDITOR_DETAILS' | translate }}</button>
      <ng-template ngbNavContent>
        <div class="tab-content-scroll position-relative">
          <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(commonDocumentEditorDetails)">
            <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
            Copia
          </button>
          <pre class="bg-light p-3 rounded small mb-0 h-100">{{ commonDocumentEditorDetails | json }}</pre>
        </div>
      </ng-template>
    </li>

    <!-- TAB: Widget Store -->
    <li [ngbNavItem]="'widgets'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.WIDGETS' | translate }}</button>
      <ng-template ngbNavContent>
        <ng-container *ngIf="widgets$ | async as widgetsData">
          <div class="tab-content-scroll position-relative">
            <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(widgetsData)">
              <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
              Copia
            </button>
            <pre class="bg-light p-3 rounded small mb-0 h-100">{{ widgetsData | json }}</pre>
          </div>
        </ng-container>
      </ng-template>
    </li>

    <!-- TAB: Gruppi Store -->
    <li [ngbNavItem]="'groups'">
      <button ngbNavLink>{{ 'PAGE.COMPLETE_STATUS.TAB.GROUPS' | translate }}</button>
      <ng-template ngbNavContent>
        <ng-container *ngIf="groups$ | async as groupsData">
          <div class="tab-content-scroll position-relative">
            <button class="btn btn-sm btn-outline-secondary copy-btn" (click)="copyToClipboard(groupsData)">
              <pt-icon class="d-flex" key="copy-outline" [size]="14"></pt-icon>
              Copia
            </button>
            <pre class="bg-light p-3 rounded small mb-0 h-100">{{ groupsData | json }}</pre>
          </div>
        </ng-container>
      </ng-template>
    </li>

  </ul>
  <div [ngbNavOutlet]="nav" class="pt-3"></div>
</div>

<div (click)="$event.stopPropagation()" class="modal-footer">
  <button (click)="dismiss()" class="btn btn-outline-secondary btn-sm" type="button" [disabled]="saving">
    {{ 'BUTTON.CLOSE' | translate }}
  </button>
  <button
    (click)="save()"
    class="btn btn-primary btn-sm"
    type="button"
    [disabled]="!canSave(getActiveChapterInfo$ | async, documentInfo$ | async, completedCtrl) || saving"
  >
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
    Aggiorna Stato Completamento
  </button>
</div>
